import TutorDetailsReview from './TutorDetailsReview'

import { reviews } from '../../../../constants'

const TutorDetailsReviews = ({ classBanner }) => {
  console.log('🚀 ~ TutorDetailsReviews ~ classBanner:', classBanner)
  // TODO: make dynamic data
  // const reviewsCount = 204;

  const reviewsContent = classBanner?.ratings?.map((review) => {
    return <TutorDetailsReview key={review?.id} review={review} />
  })

  return (
    <div className="mt-[10px] p-[20px] w-full rounded-[10px] border-[#FFCA84] border-[1px] bg-[#FFF5EE] flex items-start flex-col">
      <h4 className="w-fit px-[16px] py-[4px] bg-primary-75 text-base font-bold leading-[24px] text-white rounded-br-xl rounded-bl rounded-t mb-[12px]">
        Reviews ({classBanner?.ratings?.length})
      </h4>

      <div className="w-full flex flex-col gap-y-[12px]">{reviewsContent}</div>
    </div>
  )
}

export default TutorDetailsReviews
